export const addTemporaryIds = (itemsArray: any[]) => {
  itemsArray.forEach((group, index) => {
    group.ID = index;
  });
};
